/**
 * social-share.js
 *
 * Script to inject social media buttons into the page.
 *
 * @author    Richard J. Turner <richardt@mediatel.co.uk>
 * @license   All rights reserved.
 */
(function ($) {
    'use strict';

    var oContainer,
        onClick;

    onClick = function onClick(oEvent) {
        var oTarget = oEvent.currentTarget;

        oEvent.preventDefault();

        window.open(
            oTarget.href,
            oTarget.getAttribute('data-social-medium') || '',
            'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=400,width=600'
        );

        return false;
    };

    // We should not do anything for "Email" and "Print" links
    oContainer = $('.social-share a').not('.print, .email').not('#print, #send_email');

    if (oContainer.length) {
        oContainer.bind('click', onClick);
    }
}(jQuery));
